import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { createEspecialidadMedico } from '../services/especialidadMedicoService';
import '../styles/Professions.css';
import '../styles/theme/toast.css';

const RegistrarEspecialidadMedico = () => {
  const navigate = useNavigate();
  const [form, setForm] = useState({ nombre: '', observacion: '' });
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const [showToast, setShowToast] = useState(false);

  const validateForm = () => {
    const newErrors = {};
    if (!form.nombre.trim()) {
      newErrors.nombre = 'El nombre de la especialidad es requerido';
    } else if (form.nombre.length < 3) {
      newErrors.nombre = 'El nombre debe tener al menos 3 caracteres';
    }
    if (!form.observacion.trim()) {
      newErrors.observacion = 'La observación es requerida';
    } else if (form.observacion.length < 10) {
      newErrors.observacion = 'La observación debe tener al menos 10 caracteres';
    }
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validateForm()) return;
    setLoading(true);
    try {
      await createEspecialidadMedico({
        ESPECIALIDAD_NOMBRE: form.nombre,
        ESPECIALIDAD_OBSERVACION: form.observacion
      });
      setLoading(false);
      setShowToast(true);
      setTimeout(() => setShowToast(false), 3000);
      setTimeout(() => navigate('/especialidades-medicas'), 1200);
    } catch (err) {
      setLoading(false);
      setErrors({ api: err.response?.data?.message || 'Error al registrar especialidad' });
    }
  };

  const handleCancel = () => {
    navigate('/especialidades-medicas');
  };

  return (
    <>
      {showToast && (
        <div className="custom-toast custom-toast-success">
          ¡Especialidad registrada exitosamente!
        </div>
      )}
      <div className="create-profession-container">
        <div className="header-section">
          <h2>Registrar Especialidad Médica</h2>
        </div>
        <form className="profession-form" onSubmit={handleSubmit}>
          <div className="form-section">
            <h3>Información de la Especialidad</h3>
            <div className="form-group">
              <label htmlFor="nombre">
                Nombre de la Especialidad <span className="required">*</span>
              </label>
              <input
                type="text"
                id="nombre"
                name="nombre"
                value={form.nombre}
                onChange={handleChange}
                className={errors.nombre ? 'error' : ''}
                placeholder="Ej: Cardiología"
              />
              {errors.nombre && <span className="error-message">{errors.nombre}</span>}
            </div>
            <div className="form-group">
              <label htmlFor="observacion">
                Observación <span className="required">*</span>
              </label>
              <textarea
                id="observacion"
                name="observacion"
                value={form.observacion}
                onChange={handleChange}
                className={errors.observacion ? 'error' : ''}
                placeholder="Describe la especialidad..."
                rows="4"
              />
              {errors.observacion && <span className="error-message">{errors.observacion}</span>}
            </div>
          </div>
          {errors.api && <div className="form-error">{errors.api}</div>}
          <div className="form-actions">
            <button type="submit" className="btn-primary" disabled={loading}>
              {loading ? 'Guardando...' : 'Registrar Especialidad'}
            </button>
            <button type="button" className="btn-secondary" onClick={handleCancel} disabled={loading}>
              Cancelar
            </button>
          </div>
        </form>
      </div>
    </>
  );
};

export default RegistrarEspecialidadMedico;
